// extracted by mini-css-extract-plugin
export default {"sinDatos":"TablaDatos_sinDatos__W786k"};